"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertPermissions = exports.convertUserProject = void 0;
var tslib_1 = require("tslib");
exports.convertUserProject = function (_a) {
    var userProject = _a.userProject;
    var workspace = {
        description: userProject.projectDescription,
        title: userProject.projectTitle,
        id: userProject.links.self.match(/\/gdc\/projects\/(.+)/i)[1],
    };
    if (userProject.demoProject) {
        workspace.isDemo = true;
    }
    return workspace;
};
exports.convertPermissions = function (_a) {
    var permissions = _a.permissions;
    var workspacePermissions = Object.keys(permissions).reduce(function (acc, permission) {
        var _a;
        var hasPermission = permissions[permission];
        return tslib_1.__assign(tslib_1.__assign({}, acc), (_a = {}, _a[permission] = hasPermission === "1", _a));
    }, {});
    return workspacePermissions;
};
//# sourceMappingURL=WorkspaceConverter.js.map